export const aboutData = {
    title: "Who I am",
    description1: " I moved from Cuba to the United States as a graduate student determined to expand my skill-set, embarking in a career transition where communication, coding and tech are the foundation of my work.",
    description2: "My goal is to make a positive impact where I work, in an enviroment aligned with my values and purpose in life. When I am not coding you can find me painting, reading or playing chess online.",
    image: 2
}